<template>

    <transition
            name="landing-fade"
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            mode="out-in">

        <!-- LANDING -->
        <div class="landing" data-size="sm" v-if="!hasEntered">

            <!-- CONTENT -->
            <div class="content" v-if="hasSupport">

                <div class="intro-image">
                    <img :src="houseImage" alt="" />
                </div>

                <div class="introduction">
                    <h1>{{ landing.title }}</h1>
                    <h2>{{ landing.tagline }}</h2>
                </div>

                <div class="breakdown-insurance">

                    <div class="container">
                        <div class="row">

                            <section v-if="(aboutContent.about_heading_1 || aboutContent.about_body_1)">
                                <h3 v-html="aboutContent.about_heading_1" v-if="aboutContent.about_heading_1" :style="{ color: cssPropColor('$color-primary') }"></h3>
                                <div v-html="aboutContent.about_body_1" v-if="aboutContent.about_body_1"></div>
                                <hr />
                            </section>

                            <section v-if="(aboutContent.about_heading_2 || aboutContent.about_body_2)">
                                <h3 v-html="aboutContent.about_heading_2" v-if="aboutContent.about_heading_2" :style="{ color: cssPropColor('$color-primary') }"></h3>
                                <div v-html="aboutContent.about_body_2" v-if="aboutContent.about_body_2"></div>
                                <hr />
                            </section>

                            <progress-button
                                :method="openSesames"
                                :loadingLabel="loadingLabel"
                                :readyLabel="buttonLabel"></progress-button>

                        </div>
                    </div>

                </div>

            </div>
            <!-- END CONTENT -->

            <!-- ALT CONTENT -->
            <div class="content unsupported" v-else>
                <h1>{{ unsupported.heading }}</h1>
                <div class="intro">{{ unsupported.msg }}</div>
            </div>
            <!-- END ALT CONTENT -->

        </div>
        <!-- END LANDING -->

    </transition>

</template>


<script>

    import ProgressButton from "./ProgressButton.vue";

    let vm = {};

    export default{

        name: 'mobile-landing',

        components: {
            ProgressButton
        },

        data () {
            return {
                houseImage: '/static/images/mbr-house-mobile.png',
                buttonLabel: 'View Exposures',
                loadingLabel: 'Constructing Experience',
                unsupported: {
                    heading: 'Oops',
                    msg: 'It seems the browser you are using is incompatible with our website. Please update your browser to continue.'
                }
            }
        },

        computed: {

            hasEntered() {
                return this.$dataStore.state.interactive.entered;
            },

            landing() {
                return this.$dataStore.getters.getLandingData;
            },

            hasSupport() {
                return Modernizr.canvas && Modernizr.flexbox && Modernizr.video;
            },

            aboutContent() {
                return this.$dataStore.getters.getAboutContent;
            }

        },

        created() {

        },

        mounted() {
            vm = this;
        },

        methods: {

            /**
             * @method openSesame
             * @description
             */
            openSesames() {
                console.log('openSesames');
                this.$dataStore.dispatch('ENTER_INTERACTIVE', { val: true });
                $('.tab-content').removeClass('inactive');

                setTimeout(function() {
                    $('.nav-tabs li:first-of-type').trigger('click');
                }, 250);
            },

            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/_variables.scss';

    .landing {
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        position: relative;
        transition: all 0.3s $easeInOutQuad;
    }

    .content {
        flex: 0 0 auto;
        position: relative;
        z-index: 5;
        align-self: center;
        transition: all 0.3s $easeInOutQuad;

        & h1 {
            font-family: $font-univers-light-cn;
            font-size: 2.188rem;
            line-height: 1;
            letter-spacing: 0.64px;
            color: var(--color-primary);
            text-transform: uppercase;
            margin: 0 0 20px 0;
        }

        & h2 {
            font-family: $font-univers-bold;
            font-size: 0.938rem;
            line-height: 1.375;
            color: $base-text-color;
            margin: 0 10px 40px 10px;
        }

        & .intro {
            font-family: $font-univers-light;
            font-size: 0.938rem;
            line-height: 1.375;
            letter-spacing: 0.58px;
            color: $white-100;
            margin: 0 0 30px 0;
        }
    }

</style>

<style lang="scss">

    @import '../assets/styles/helpers/variables';

    .landing[data-size="sm"] {

        & .content {
            width: 100%;
            max-width: 780px;

            &.unsupported {
                padding: 50px 100px;

                & .intro {
                    margin: 0 0 0 0;
                }
            }

            & h1 {
                font-family: $font-univers-light-cn;
                font-size: 1.750rem;
                color: $white-100;
            }

            & h2 {
                color: $white-100;
            }

            & .intro-image {
                line-height: 0;

                & > img {
                    max-width: 100%;
                    height: auto;
                }
            }

            & .introduction {
                background-color: var(--color-primary);
                padding: 2.813rem 1.875rem;

                & h2 {
                    font-family: $font-univers-bold;
                    font-size: 0.875rem;
                    margin-bottom: 0;
                }
            }

            & h1 {
                margin: 0 0 1rem 0;
            }

            & h2 {
                letter-spacing: normal;
            }

            & .intro {
                font-family: $font-univers-std;
                font-size: 0.750rem;
                font-weight: normal;
                color: $white-100;
                line-height: 1.500;
                letter-spacing: normal;
                margin: 0 0 1rem 0;
            }

            & .breakdown-insurance {
                padding: 1.875rem 1.875rem 1.875rem;

                & .container {
                    width: 100%;
                }

                & section {

                    & h3 {
                        font-family: $font-univers-bold;
                        font-size: 1rem;
                        font-weight: normal;
                        letter-spacing: normal;
                    }

                    & div {
                        font-family: $font-univers-std;
                        font-size: 0.875rem;
                        font-weight: normal;
                        line-height: 1.500;
                        letter-spacing: normal;
                    }

                    &:last-of-type {

                        & hr {
                            margin-bottom: 0;
                            opacity: 0;
                        }
                    }
                }

                & button {

                    &.ready {
                        width: 115px !important;
                        height: 30px !important;
                    }

                    & .label {
                        font-size: 0.750rem !important;
                        letter-spacing: normal !important;
                    }
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// MobileLanding.vue?f9f46a2c